import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import Constant from '../../Constant'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
class DiwaniyaList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    cat: this.props.match.params.boatType,
  }
  handleStatusChange = (sid, status) => {
    let newArray = this.state.Products_data

    var a = newArray.find((element) => {
      return element.id === sid
    })

    if (a) {
      a.is_active = status
      var data = new FormData()
      data.append('is_active', a.is_active)
      data.append('id', a.id)

      axios
        .put(Constant.getAPI() + `/items/update-diwaniya`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          this.setState({ Products_data: newArray })
          Swal.fire('Update Status!', 'Status has been updated.', 'success')
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  deleteProducts = (id) => {
    //var cruiseId = this.props.match.params.boatId
    axios
      .delete(Constant.getAPI() + `/items/delete-diwaniya/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        Swal.fire({
          title: 'Diwaniya Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.dashbord()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  componentDidMount() {
    this.dashbord()
  }
  dashbord = async () => {
    var that = this
    this.setState({ isloading: true })
    var cruiseId = this.props.match.params.boatId
    await axios
      .get(Constant.getAPI() + `/items/list-cruise-diwaniya/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ isloading: false })
          that.setState({
            Products_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'item_img',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (cruise_thumb_img) => {
            return (
              <div>
                {cruise_thumb_img !== null ? (
                  <div>
                    {cruise_thumb_img?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                              ? Constant.getImage() + cruise_thumb_img
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                            ? Constant.getImage() + cruise_thumb_img
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      cruise_thumb_img !== undefined && cruise_thumb_img !== null && cruise_thumb_img !== {}
                        ? Constant.getImage() + cruise_thumb_img
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'item_name_en',
        label: `Name:English`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'item_name_ar',
        label: `Name:Arabic`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'item_amount',
        label: 'Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'amount_goes_to',
        label: 'Amount Goes to',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'category',
        label: 'Category',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return data?.name_en || '--'
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={'status' + tableMeta.rowData[8]}
                checked={is_active === true}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[8], !is_active)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={
                    `/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/diwaniya-add/` +
                    id
                  }
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                {/* <span
                  onClick={this.deleteProducts.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span> */}
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.props.match.params.boatType} Diwaniya List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/diwaniya-add`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i>
                    {this.props.match.params.boatType} Diwaniya Add
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link
                          to={`/viewboat-details/${this.props.match.params.boatType}/${this.props.match.params.boatId}`}
                        >
                          {this.props.match.params.boatType} Details{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{this.props.match.params.boatType} Diwaniya List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`${this.props.match.params.boatType} Diwaniya List`}
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DiwaniyaList
